exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.big.el-select[data-v-46077e0b] {\n  width: 450px;\n}\n.biggest.el-textarea[data-v-46077e0b] {\n  width: 700px;\n}\n.el-checkbox__label[data-v-46077e0b] {\n  background-color: transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46077e0b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roleSpecific/AuditorJudgement.vue
// module id = uYzh
// module chunks = 1